export const SET_TABLE_COLUMNS_ORDER = "SET_TABLE_COLUMNS_ORDER";
export const SET_TABLE_CONFIG = "SET_TABLE_CONFIG";
export const CLEAN_TABLE_COLUMNS_ORDER = "CLEAN_TABLE_COLUMNS_ORDER";
